import { EntityTrait } from '@/models/entity';
import { ArticleWithRelations, RequestWithRelations } from '@/models/request';

export const getRequestIam = (request: RequestWithRelations) => {
  return {
    scopesOnRequest: request.scopes,
    hasUserScopeOnRequest: (scope: EntityTrait | 'organization') =>
      request.scopes.some((sc) => sc.scope === scope),
    hasOnlyWorkshopScopeOnRequest:
      !!request.scopes.length &&
      request.scopes.every((scopeOnRequest) => scopeOnRequest.scope === 'workshop'),
    hasOnlyExternalWorkshopScopeOnRequest:
      !!request.scopes.length &&
      request.scopes.every(
        (scopeOnRequest) => scopeOnRequest.scope === 'workshop' && scopeOnRequest.external
      ),
  };
};

export const getArticleIam = (article: ArticleWithRelations) => {
  return {
    hasUserScopeOnArticle: (scope: EntityTrait | 'organization') =>
      article.scopes.some((sc) => sc.scope === scope),
    hasOnlyWorkshopScopeOnArticle:
      !!article.scopes.length &&
      article.scopes.every((scopeOnArticle) => scopeOnArticle.scope === 'workshop'),
    hasOnlyExternalWorkshopScopeOnArticle:
      !!article.scopes.length &&
      article.scopes.every(
        (scopeOnArticle) => scopeOnArticle.scope === 'workshop' && scopeOnArticle.external
      ),
  };
};
